export default "/fonts/vendor/katex/dist/KaTeX_Size1-Regular.woff2?6eec866c69313624be6061a5c86f0944";